/*
 * Js files imported
*/
import "core-js/stable";
import "regenerator-runtime/runtime";
import * as jQuery from 'jquery';
import 'jquery.are-you-sure';
import 'jquery-color';
window.$ = jQuery
window.jQuery = jQuery

import Highcharts from 'highcharts';
import addHighChartsMore from 'highcharts/highcharts-more'
import addHighChartsExporting from 'highcharts/modules/exporting'
import addHighChartsHeatMap from 'highcharts/modules/heatmap'
import addHighChartsSolidGauge from 'highcharts/modules/solid-gauge'
import addHighChartsWordcloud from 'highcharts/modules/wordcloud'
addHighChartsMore(Highcharts)
addHighChartsExporting(Highcharts)
addHighChartsHeatMap(Highcharts)
addHighChartsSolidGauge(Highcharts)
addHighChartsWordcloud(Highcharts)
window.Highcharts = Highcharts;

import 'lodash';
import 'bootstrap';
import 'bootstrap-datepicker';
import 'fastclick';
import html2canvas from 'html2canvas';
import 'promise-polyfill';
import 'select2';
import Vue from 'vue';
import { createApp } from 'vue';
import 'vue-router';
import cronTime from "cron-time-generator";
import cronstrue from 'cronstrue';
import Pusher from 'pusher-js';
import { DateTime } from "luxon";

// prepend [Cake Shim] to all console.[warn, error] messages
window.existingComponentMessages = [];
const hookIntoConsoleMessages = () => {
	const prependIdentifier = '[Cake Shim] ';
    const ignoreWarnMessage = 'Component "(?<name>.*)" has already been registered in target app.';
	const oldWarn = console.warn;
	console.warn = function (str) {
		// ignore all console.warn messages that match the regex Component "(.*)" has already been registered in target app.
		// On DOMContentLoaded, we will group all of these together in a single message
		if (str.match(ignoreWarnMessage)) {
			window.existingComponentMessages.push(str.match(ignoreWarnMessage).groups.name);
			return;
		}
		oldWarn(str.indexOf(prependIdentifier) === 0 ? str : `${prependIdentifier}${str}`);
	};
	const oldError = console.error;
	console.error = function (str) {
		oldError(str.indexOf(prependIdentifier) === 0 ? str : `${prependIdentifier}${str}`);
	};

	document.addEventListener('DOMContentLoaded', () => {
		// warn about duplicate components (only unique values)
		if (window.existingComponentMessages.length > 0) {
			oldWarn(prependIdentifier + 'Duplicate Components: ' + [
				...new Set(window.existingComponentMessages)
			].join(', '));
		}
	});
};
if (process.env.NODE_ENV !== 'production') {
	hookIntoConsoleMessages();
}


window.Vue = Vue;
window.html2canvas = html2canvas;
window.cronTime = cronTime;
window.cronstrue = cronstrue;
window.DateTime = DateTime;
window.Pusher = Pusher;

import tinycolor from "tinycolor2";
window.tinycolor = tinycolor;

import DatePicker from 'vue2-datepicker';
window.DatePicker = DatePicker;

/*
 * Css files imported
import '../webroot/css/hydracor.login.css';
import '../webroot/css/hydracor.bootstrap-override.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import 'bootstrap-datetimepicker-npm/build/css/bootstrap-datetimepicker.min.css';
import 'select2/dist/css/select2.min.css';
*/
